import React from 'react';
import { CheckCircleOutlined, UserOutlined, SafetyCertificateOutlined, WalletOutlined, RightOutlined } from '@ant-design/icons';

interface StepTrackingProps {
  currentStep: number;
  completedSteps: number[];
}

const StepTracking: React.FC<StepTrackingProps> = ({ currentStep, completedSteps }) => {
  const steps = [
    {
      key: 0,
      title: 'Personal data',
      description: 'Basic information',
      icon: <UserOutlined />
    },
    // {
    //   key: 1,
    //   title: 'Email verification',
    //   description: 'Verify your email',
    //   icon: <MailOutlined />
    // },
    {
      key: 2,
      title: 'Employment and finance',
      description: 'Identity verification',
      icon: <SafetyCertificateOutlined />
    },
    {
      key: 3,
      title: 'Final Step',
      description: 'Activate your account',
      icon: <WalletOutlined />
    }
  ];

  const getStepStatus = (stepKey: number) => {
    if (completedSteps.includes(stepKey)) return 'completed';
    if (stepKey === currentStep) return 'active';
    return 'pending';
  };

  return (
    <div className="!w-full !px-4 sm:!px-6 !py-2 !h-fit">
      <div className="!flex !items-center !justify-center !gap-2 sm:!gap-4">
        {steps.map((step, index) => {
          const status = getStepStatus(step.key);
          const isLast = index === steps.length - 1;

          return (
            <div key={step.key} className="!relative">
              <div className="!flex !items-center !gap-1 sm:!gap-2">
                <div className='flex md:flex-row flex-col items-center md:gap-2 gap-1'>
                  {/* Step Marker */}
                  <div className={`
                    !flex !items-center !justify-center !w-6 !h-6 sm:!w-8 sm:!h-8 !rounded-full !flex-shrink-0 !transition-all !duration-300
                    ${status === 'completed' ? '!bg-green-500' : 
                      status === 'active' ? '!bg-[#e9b460] !shadow-lg !shadow-[#e9b460]/50' : 
                      '!bg-white/10 !border-2 !border-white/30'}
                  `}>
                    {status === 'completed' ? (
                      <CheckCircleOutlined className="!text-white !text-sm sm:!text-xl" />
                    ) : (
                      <div className={`!text-xs sm:!text-sm ${status === 'active' ? '!text-white' : '!text-white/60'}`}>
                        {React.cloneElement(step.icon, {
                          className: '!text-current'
                        })}
                      </div>
                    )}
                  </div>
                  
                  {/* Step Content */}
                  <div className="!flex-1">
                    <div className={`
                      !text-xs sm:!text-base !font-semibold !transition-colors !duration-300 !whitespace-nowrap
                      ${status === 'completed' ? '!text-green-400' : 
                        status === 'active' ? '!text-[#e9b460]' : 
                        '!text-white'}
                    `}>
                      {step.title}
                    </div>
                  </div>
                </div>

                {/* Connector Line */}
                {!isLast && (
                  <div className="!flex !items-center !px-1">
                    <RightOutlined className={`
                      !text-sm sm:!text-lg !transition-colors !duration-300
                      ${status === 'completed' ? '!text-green-500' : 
                        status === 'active' ? '!text-[#e9b460]' : 
                        '!text-white/30'}
                    `} />
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <hr className="!border-t-2 !border-white/30 !mt-2" />
    </div>
  );
};

export default StepTracking;
